import { render, staticRenderFns } from "./RenovacionRapidaComponent.vue?vue&type=template&id=56bd74aa&scoped=true"
import script from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
export * from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
import style0 from "./RenovacionRapidaComponent.vue?vue&type=style&index=0&id=56bd74aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd74aa",
  null
  
)

export default component.exports